import { psychosisHearingVoicesArticle } from 'assets/data/blogPostContent/psychosisHearingVoicesArticle'
import { understandingBipolarArticle } from 'assets/data/blogPostContent/understandingBipolarArticle'
import { understandingDepressionArticle } from 'assets/data/blogPostContent/understandingDepressionArticle'
import { understandingSpiritualCrisisArticle } from 'assets/data/blogPostContent/understandingSpiritualCrisisArticle'
import { understandingSelfHarmArticle } from 'assets/data/blogPostContent/understandingSelfHarmArticle'
import { problemsWithEatingArticle } from 'assets/data/blogPostContent/problemsWithEatingArticle'
import { obsessionsAndCompulsionsArticle } from 'assets/data/blogPostContent/obsessionsAndCompulsionsArticle'
import { understandingAnxietyArticle } from 'assets/data/blogPostContent/understandingAnxietyArticle'
import { traumaAndPTSDArticle } from 'assets/data/blogPostContent/traumaAndPTSDArticle'
import type { ResourceArticle } from '~/types/ResourceArticle'

export const blogPostContent: ResourceArticle[] = [
  psychosisHearingVoicesArticle,
  understandingBipolarArticle,
  understandingDepressionArticle,
  understandingSpiritualCrisisArticle,
  understandingSelfHarmArticle,
  problemsWithEatingArticle,
  obsessionsAndCompulsionsArticle,
  understandingAnxietyArticle,
  traumaAndPTSDArticle
]
